export default __webpack_public_path__ + "static/google-play-c17ff75bfe486b7ab3aaa452e717ebb7.png";